module.exports = __webpack_public_path__ + "static/media/orquestra_salao_8.6d161145.jpg";